import {formatter, request} from '@/utils/request';

export namespace FormSpMkt {
  export const Path = {
    get: '/expenseapi/formSpMkt/getFormSpMkt',
    paymentMktPrev: '/expenseapi/formSpMkt/paymentMktPrev',
    GetSap: '/expenseapi/formSpMkt/getSap',
    GetSapForFormId: '/expenseapi/formSpMkt/getSapForFormId',
    spMktPrintUrl: '/reportapi/print/formSpMktPrint',

  };

  export async function get(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.FormSpMkt>>(Path.get, formatter(options));
  }

  export async function getSap(supplierCode: string) {
    const options = {
      method: 'GET',
      body: {
        supplierCode: supplierCode,
      },
    };
    return request<API.ResponseResult<any[]>>(Path.GetSap, formatter(options));
  }

  export async function getSapForFormId(formId: number) {
    const options = {
      method: 'GET',
      body: {
        formId: formId,
      },
    };
    return request<API.ResponseResult<any[]>>(Path.GetSap, formatter(options));
  }

  export async function paymentMktPrev(body: API.PaymentMktPrev) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.PaymentPrev>>(Path.paymentMktPrev, formatter(options));
  }

  export namespace Buttons {
    export const Path = {
      Apply: '/expenseapi/spMktButtons/apply',
      Delete: '/expenseapi/spMktButtons/delete',
      Get: '/expenseapi/spMktButtons/get',
      GetDynamicInformation: '/expenseapi/spMktButtons/getDynamicInformation',
      DownloadModifyAmountTable: '/expenseapi/spMktButtons/downloadModifyAmountTable',
      DownloadModifyVoucherNoTable: '/expenseapi/spMktButtons/downloadModifyVoucherNoTable',
      ModifyAmount: '/expenseapi/spMktButtons/modifyAmount',
      WARNING_INFOS: '/expenseapi/spMktButtons/warningInfos',
      COUNT_OF_WARNING: '/expenseapi/spMktButtons/countOfWarning',

    };

    export async function warningInfos(formId: number) {
      const options = {
        method: 'GET',
        body: {
          formId: formId,
        },
      };
      return request<API.ResponseResult<API.WdiPanelList>>(Path.WARNING_INFOS, formatter(options));
    }

    export async function countOfWarning(formId: number) {
      const options = {
        method: 'GET',
        body: {
          formId: formId,
        },
      };
      return request<API.ResponseResult<number>>(Path.COUNT_OF_WARNING, formatter(options));
    }

    export async function get(body: API.ButtonArgs) {
      const options = {
        method: 'POST',
        body: {
          ...body,
        },
      };

      return request<API.ResponseResult<API.Button>>(Path.Get, formatter(options));
    }

    export async function apply(body: {
      form: API.Form;
      formSpMkt: API.FormSpMkt;
      formSpMktDetails: API.FormSpMktDetail[];
      invoices?: API.Invoice[];
    }) {
      const options = {
        method: 'POST',
        body: {
          ...body,
        },
      };
      return request<API.ResponseResult<API.WdiPanelList>>(Path.Apply, formatter(options));
    }

    export async function del(formId: number) {
      const options = {
        method: 'POST',
        body: {
          formId: formId,
        },
      };
      return request<API.ResponseResult<API.WdiPanelList>>(Path.Delete, formatter(options));
    }

    export async function getDynamicInformation(formId: number) {
      const options = {
        method: 'Get',
        body: {formId},
      };
      return request<API.DynamicInformation[]>(Path.GetDynamicInformation, formatter(options));
    }

    export async function modifyAmount(body: { pageTypeId: number, formSpMktDetail: any, }) {
      const options = {
        method: 'POST',
        body: {
          ...body,
        },
      };

      return request<API.ResponseResult<any>>(Path.ModifyAmount, formatter(options));
    };
  }
}

export namespace FormSpMktDetail {
  export const Path = {
    getsForApply: '/expenseapi/formSpMkt/getFormSpMktDetailsForApply',
    getsForApproval: '/expenseapi/formSpMkt/getFormSpMktDetailsForApproval',
    getByFormId: '/expenseapi/formSpMkt/getByFormId'
  };

  export async function getsForApply(body: API.FormSpMktDetailApplyParam) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.FormSpMktDetailApplyView[]>>(
      Path.getsForApply,
      formatter(options),
    );
  }

  export async function getsForApproval(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.FormSpMktDetailApprovalView[]>>(
      Path.getsForApproval,
      formatter(options),
    );
  }

  export async function getByFromId(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.FormSpMktDetailApprovalView[]>>(
      Path.getByFormId,
      formatter(options),
    );
  }
}
